import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.object.to-string";
import "core-js/modules/web.dom-collections.for-each";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import { serchSelect, tabulation } from "@/mixins/index";
import { getReviews } from "@/api/chatbot/chatbot";
export default {
  name: "reviewHistoryList",
  mixins: [serchSelect, tabulation],
  data: function data() {
    return {
      kindList: [{
        label: '全部',
        value: ''
      }, {
        label: 'table_description',
        value: 'table_description'
      }, {
        label: 'field_alias',
        value: 'field_alias'
      }, {
        label: 'entity_mapping',
        value: 'entity_mapping'
      }, {
        label: 'ownership_doc',
        value: 'ownership_doc'
      }, {
        label: 'fixed_filter',
        value: 'fixed_filter'
      }, {
        label: 'metric_definition',
        value: 'metric_definition'
      }, {
        label: 'example_sql',
        value: 'example_sql'
      }, {
        label: 'global_policy',
        value: 'global_policy'
      }, {
        label: 'metric_policy',
        value: 'metric_policy'
      }, {
        label: 'data_model_policy',
        value: 'data_model_policy'
      }, {
        label: 'feedback_note',
        value: 'feedback_note'
      }],
      searchData: {
        page: 1,
        limit: 30
      },
      tableData: [],
      allTableData: []
    };
  },
  created: function created() {},
  computed: {},
  methods: {
    searchClick: function searchClick(e) {
      var _this = this;

      if (e == 1) {
        this.searchData.page = 1;
      }

      this.reqLoading = true;
      getReviews(this.searchData).then(function (res) {
        var items = res.items || []; // 2. 循环加工映射数据

        var processedItems = items.map(function (item) {
          // 1. group 长度
          var groupLen = Array.isArray(item.group) ? item.group.length : 0; // const disableLen = would disable; 
          // 3. checks 长度

          var checksLen = Array.isArray(item.preview_checks) ? item.preview_checks.length : 0;
          var metricsSum = 0;
          var contextSum = 0;
          var currentSum = 0;
          var candidateSum = 0;

          if (Array.isArray(item.preview_checks)) {
            item.preview_checks.forEach(function (check) {
              metricsSum += check.metric_count || 0;
              contextSum += check.context_chars || 0;
              currentSum += check.current_context_chars || 0;
              candidateSum += check.candidate_context_chars || 0;
            });
          } // 将计算好的结果挂载到 item 本身，方便模板直接读取


          return _objectSpread(_objectSpread({}, item), {}, {
            _groupLen: groupLen,
            // _disableLen: disableLen,
            _checksLen: checksLen,
            _metricsSum: metricsSum,
            _contextSum: contextSum,
            _currentSum: currentSum,
            _candidateSum: candidateSum
          });
        });
        _this.allTableData = processedItems;

        _this.renderCurrentPageData(); // 分页断言：如果返回的条数等于期望的 limit 条数，说明潜在还有下一页

      }).finally(function () {
        _this.reqLoading = false;
      });
    },
    renderCurrentPageData: function renderCurrentPageData() {
      var start = (this.searchData.page - 1) * this.searchData.limit;
      var end = start + this.searchData.limit;
      this.tableData = this.allTableData.slice(start, end);
      this.hasMore = this.allTableData.length > end;
    },
    changePage: function changePage(targetPage) {
      if (targetPage < 1) return;
      this.searchData.page = targetPage;
      this.renderCurrentPageData();
    },
    // 切换单页条数事件
    sizeChange: function sizeChange(val) {
      this.searchData.limit = val;
      this.searchData.page = 1;
      this.renderCurrentPageData();
    }
  }
};